export default '95B8E';
